module.exports = __webpack_public_path__ + "img/w6_feature_01.6d36bde9.jpg";